import React, { useState } from "react";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import "./AppShell.css";

export default function AppShell({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="ng-shell">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="ng-shell__main">
        <TopBar onMenuClick={() => setSidebarOpen(true)} />
        <div className="ng-shell__content">
          {children}
        </div>
      </div>
    </div>
  );
}
